import { ApiCall } from "../apiBase";
/********get all bookings query********/
export async function getBookings() {
	let bookings = [];

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
        query getBookings {
          getBookings {
            id
            bookingType
            startTime
            endTime
            status
            totalPrice
            numOfPacks
            reserverName
            reserverEmail
            reserverTelephone
            bookingNote
            paymentMethod
            paymentId
            subPackage {
              id
              title
              duration
              price
              package {
                id
                title
              }
            }
            extras {
              id
              title
            }
          }
        }
      `,
		},
	});

	if (!result.data.errors && result.data.data.getBookings) {
		bookings = result.data.data.getBookings;
	}

	return bookings;
}

/********get a Booking by it's id query********/
export async function getBookingById(bookingId) {
	let bookingRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
        query getBookingById($id: ID!) {
          getBooking(id: $id) {
            id
            bookingType
            startTime
            endTime
            status
            totalPrice
            numOfPacks
            reserverName
            reserverEmail
            reserverTelephone
            paymentMethod
            paymentId
            subPackage {
              title
            }
            extras {
              title
            }
          }
        }
      `,
			variables: {
				id: bookingId,
			},
		},
	});

	if (!result.data.errors && result.data.data.getBooking) {
		bookingRes = result.data.data.getBooking;
	}

	return bookingRes;
}

/********add a booking mutation********/
export async function addBooking(newBooking) {
	let addBookingRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
            mutation addBooking($input: BookingInput!) {
              addBooking(input: $input) {
                id
                bookingType
                startTime
                endTime
                bookingNote
                paymentMethod
              }
            }
          `,
			variables: {
				input: {
					bookingType: newBooking.bookingType ? newBooking.bookingType : null,
					startTime: newBooking.startTime ? newBooking.startTime : null,
					endTime: newBooking.endTime ? newBooking.endTime : null,
					bookingNote: newBooking.bookingNote ? newBooking.bookingNote : null,
					numOfPacks: newBooking.numOfPacks ? newBooking.numOfPacks : 1,
					subPackage: newBooking.subPackage ? newBooking.subPackage : null,
					extras: newBooking.extras ? newBooking.extras : null,
					totalPrice: newBooking.totalPrice ? newBooking.totalPrice : 0,
					reserverName: newBooking.reserverName
						? newBooking.reserverName
						: "Ms Sissi - Außer Betrieb",
					reserverEmail: newBooking.reserverEmail
						? newBooking.reserverEmail
						: "office@ms-sissi.at",
					reserverAddress: newBooking.reserverAddress
						? newBooking.reserverAddress
						: "",
					reserverTelephone: newBooking.reserverTelephone
						? newBooking.reserverTelephone
						: "",
				},
			},
		},
	});

	if (!result.data.errors && result.data.data.addBooking) {
		addBookingRes = result.data.data.addBooking;
	}

	return addBookingRes;
}

/********update a packge mutation********/
export async function updateBooking(updatedBooking) {
	let updateBookingRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
        mutation updateBooking($id: ID!, $input: BookingInput!) {
          updateBooking(id: $id, input: $input) {
              id
              bookingType
              startTime
              endTime
              status
              totalPrice
              numOfPacks
              reserverName
              reserverEmail
              reserverTelephone
              paymentMethod
              bookingNote
              subPackage {
                title
                package {
                  title
                }
              }
              extras {
                title
              }
          }
        }
      `,
			variables: {
				id: updatedBooking.id,
				input: {
					startTime: updatedBooking.startTime,
					endTime: updatedBooking.endTime,
					numOfPacks: updatedBooking.numOfPacks,
					subPackage: updatedBooking.subPackage,
					status: updatedBooking.status,
					extras: updatedBooking.extras,
					totalPrice: updatedBooking.totalPrice,
					reserverName: updatedBooking.reserverName,
					reserverEmail: updatedBooking.reserverEmail,
					reserverTelephone: updatedBooking.reserverTelephone,
					bookingNote: updatedBooking.note,
					bookingType: updatedBooking.type,
				},
			},
		},
	});

	if (!result.data.errors && result.data.data.updateBooking) {
		updateBookingRes = result.data.data.updateBooking;
	}
	return updateBookingRes;
}

/********update a service booking mutation********/
export async function updateServiceBooking(updatedBooking) {
	let updateServiceBookingRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
        mutation updateServiceBooking($id: ID!, $input: BookingInput!) {
          updateServiceBooking(id: $id, input: $input) {
              id
              bookingType
              startTime
              endTime
              status
              totalPrice
              numOfPacks
              reserverName
              reserverEmail
              reserverTelephone
              paymentMethod
              bookingNote
              subPackage {
                title
                package {
                  title
                }
              }
              extras {
                title
              }
          }
        }
      `,
			variables: {
				id: updatedBooking.id,
				input: {
					startTime: updatedBooking.startTime,
					endTime: updatedBooking.endTime,
					numOfPacks: updatedBooking.numOfPacks,
					subPackage: updatedBooking.subPackage,
					status: updatedBooking.status,
					extras: updatedBooking.extras,
					totalPrice: updatedBooking.totalPrice,
					reserverName: updatedBooking.reserverName,
					reserverEmail: updatedBooking.reserverEmail,
					reserverTelephone: updatedBooking.reserverTelephone,
					bookingNote: updatedBooking.note,
					bookingType: updatedBooking.type,
				},
			},
		},
	});
	if (!result.data.errors && result.data.data.updateServiceBooking) {
		updateServiceBookingRes = result.data.data.updateServiceBooking;
	}
	return updateServiceBookingRes;
}

/********delete a Booking mutation********/
export async function deleteBooking(bookingId) {
	let deleteSuccess = false;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
          mutation deleteBooking($id: ID!) {
            deleteBooking(id: $id) {
              id
              bookingType
              startTime
              endTime
              status
              totalPrice
              numOfPacks
              reserverName
              reserverEmail
              reserverTelephone
              bookingNote
              paymentMethod
              subPackage {
                title
                package {
                  title
                }
              }
              extras {
                title
              }
            }
          }
        `,
			variables: {
				id: bookingId,
			},
		},
	});

	if (!result.data.errors && result.data.data.deleteBooking) {
		deleteSuccess = true;
	}

	return deleteSuccess;
}

/****************** Confirm booking ***************/
export async function updateBookingStatusToConfirm(bookingId) {
	let bookingConfirmSuccess = true;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
          mutation updateBookingStatusToConfirm($id: ID!) {
            updateBookingStatusToConfirm(id: $id) {
              id
              bookingType
              startTime
              endTime
              status
              totalPrice
              numOfPacks
              reserverName
              reserverEmail
              reserverTelephone
              bookingNote
              paymentMethod
              subPackage {
                title
                package {
                  title
                }
              }
              extras {
                title
              }
            }
          }
        `,
			variables: {
				id: bookingId,
			},
		},
	});

	if (!result.data.errors && result.data.data.updateBookingStatusToConfirm) {
		bookingConfirmSuccess = true;
	}

	return bookingConfirmSuccess;
}

/***************** Get Total Amount From Booking ****************/
export async function getTotalAmountEarnedFromBooking() {
	let totalAmount = 0;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
        query getTotalAmountFromBookings {
          getTotalAmountFromBookings
        }
      `,
		},
	});

	if (!result.data.errors && result.data.data.getTotalAmountFromBookings) {
		totalAmount = result.data.data.getTotalAmountFromBookings;
	}

	return totalAmount;
}

/*******check package availability********/
export async function checkAvailability(startTime, endTime) {
	let availabilityRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
      query checkAvailability($startTime: DateTime!, $endTime: DateTime!){
        checkAvailability(startTime: $startTime, endTime: $endTime) {
            isAvailable
            alternatives{
              date
            }
          }
        }`,
			variables: {
				startTime: startTime,
				endTime: endTime,
			},
		},
	});

	if (!result.data.errors && result.data.data.checkAvailability) {
		availabilityRes = result.data.data.checkAvailability;
	}

	return availabilityRes;
}

/******** check booking availability when updating a booking ********/
export async function checkUpdateBookingAvailability(
	startTime,
	endTime,
	bookingId
) {
	let availabilityRes = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
      query checkUpdateBookingAvailability($startTime: DateTime!, $endTime: DateTime!, $bookingId: ID!){
        checkUpdateBookingAvailability(startTime: $startTime, endTime: $endTime, bookingId: $bookingId) {
            isAvailable
            alternatives{
              date
            }
          }
        }`,
			variables: {
				startTime: startTime,
				endTime: endTime,
				bookingId: bookingId,
			},
		},
	});
	if (!result.data.errors && result.data.data.checkUpdateBookingAvailability) {
		availabilityRes = result.data.data.checkUpdateBookingAvailability;
	}

	return availabilityRes;
}

export async function getInvoiceNumber(bookingId) {
	let invoiceNo = null;

	const result = await ApiCall({
		method: "post",
		data: {
			query: `
      query getInvoiceByBookingId($bookingId: ID!) {
        getInvoiceByBookingId(bookingId: $bookingId) {
          invoiceNumber
        }
      }`,
			variables: {
				bookingId: bookingId,
			},
		},
	});
	if (
		!result.data.errors &&
		result.data.data.getInvoiceByBookingId.invoiceNumber
	) {
		invoiceNo = result.data.data.getInvoiceByBookingId.invoiceNumber;
	}
	return invoiceNo;
}
